<script>
    import { onMount } from "svelte";
    import ajaxFetch from "../services/ajaxFetch.js";
    import TrendCinema from "../components/TrendCinema.svelte";

    /**
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        errorCallback,
        performance,
        cinemaInjectionContainerWidth = 1000,
        featureIndex,
        index,
        additionalTrackingLabels = null,
    } = $props();

    let cinemaHasLoaded = $state(false);
    let headline = $state(),
        recommendations = $state(),
        tracking = $state(),
        additionalClickTracking = $state(),
        metaData = $state(),
        transparentBackground = $state(),
        featuresState = $state();

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const res = await ajaxFetch(`/reco-core/recommendations/trend/`);
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({
            headline,
            recommendations,
            tracking,
            additionalClickTracking,
            metaData,
            featuresState,
            transparentBackground = false,
        } = await res.json());
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <TrendCinema
        {headline}
        {transparentBackground}
        {recommendations}
        {tracking}
        {featureIndex}
        {additionalClickTracking}
        {performance}
        {additionalTrackingLabels}
        {cinemaInjectionContainerWidth}
        cinemaIndex={index}
        cinemaMeta={metaData}
        {featuresState}
    />
{/if}
